import script from "./ImpostorsCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./ImpostorsCarousel.vue?vue&type=script&setup=true&lang=js"

import "./ImpostorsCarousel.vue?vue&type=style&index=0&id=2f4cc384&scoped=true&lang=scss"
import "./ImpostorsCarousel.vue?vue&type=style&index=1&id=2f4cc384&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f4cc384"]])

export default __exports__